import { Tabs } from "antd";
import '../../style/community.css';
import EarningsEventsView from "../../components/ai/earnings_events_view";
import EconomicEventsView from "../../components/ai/economic_events_view";

const AIArticleNotificationScreen = () => {

    const tabItems = [
        { label: 'Earnings Events', key: '1', children: <EarningsEventsView /> }, 
        { label: 'Economic Events', key: '2', children: <EconomicEventsView />}
    ];
    return (
        <div className='main-wrapper'>
            <div className='cnt-item'>
                <Tabs items={tabItems} tabBarStyle={{ paddingLeft: 16 }} />
            </div>

        </div>
    )
}

export default AIArticleNotificationScreen;